function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyWishlistClick = function SvgMyWishlistClick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M700.9 122.5c-71.5 0-138.6 29-191.7 82.3-44.7-50.8-114.1-82.3-185-82.3-140.8 0-259.6 118.9-259.6 259.6C64.6 626 346.5 845.6 504.3 900c2.7.9 5.5 1.4 8.3 1.4s5.6-.5 8.3-1.4c157.8-54.4 439.7-274 439.7-517.9-.1-140.7-119-259.6-259.7-259.6",
    style: {
      fill: "#d90b17"
    }
  }));
};
export default SvgMyWishlistClick;